import { render, staticRenderFns } from "./CSRoot.vue?vue&type=template&id=5c37f4a3&lang=pug&"
import script from "./CSRoot.vue?vue&type=script&lang=js&"
export * from "./CSRoot.vue?vue&type=script&lang=js&"
import style0 from "./CSRoot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports